export const getRelativeTime = (isoDate) => {
    const now = new Date();
    const then = new Date(isoDate);
    const diff = Math.max(0, now - then);

    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (years >= 1) return years === 1 ? '1 year ago' : `${years} years ago`;
    if (months >= 1) return months === 1 ? '1 month ago' : `${months} months ago`;
    if (weeks >= 1) return weeks === 1 ? '1 week ago' : `${weeks} weeks ago`;
    if (days >= 1) return days === 1 ? '1 day ago' : `${days} days ago`;
    if (hours >= 1) return hours === 1 ? '1 hour ago' : `${hours} hours ago`;
    if (minutes >= 1) return minutes === 1 ? '1 minute ago' : `${minutes} minutes ago`;
    if (seconds <= 1) return 'just now';
    return `${seconds} seconds ago`;
};